export default __webpack_public_path__ + "static/media/service-8.fdb0d324.jpg";